export default {
  buttons: {
    back: 'Terug',
  },
};
